import emptySplitApi from "../utils/rtk";
import { END_POINTS } from "../helpers";
import { CommonBody } from "../types/General";

type CommonResponseType = {
  statusCode: number;
  message: string;
  s3Location?: string;
};

export const promoCodeApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getAllPromos: builder.query<
      CommonResponseType & { data: any },
      {
        page?: number;
        search?: string;
        isDelete?: boolean;
        status?: number;
      }
    >({
      query: ({ page, search, isDelete, status }) => {
        let url = `${END_POINTS.getAllPromos}?page=${page}${
          isDelete ? `&isDelete=${isDelete}` : ""
        }${status ? `&status=${status}` : ""}${
          search ? `&search=${search}` : ""
        }`;

        return {
          url: url,
          method: "GET",
        };
      },
    }),

    getPromoById: builder.query<
      CommonResponseType & { data: any },
      { id: any }
    >({
      query: ({ id }) => ({
        url: `${END_POINTS.getPromoById}/${id}/`,
        method: "GET",
      }),
    }),
    updatePromo: builder.mutation<
      CommonResponseType & { data: CommonBody },
      { id: string | undefined; body: CommonBody }
    >({
      query: ({ body, id }) => ({
        url: `${END_POINTS.updatePromo}/${id}`,
        method: "PUT",
        body,
      }),
    }),

    addPromo: builder.mutation<
      CommonResponseType & { data: CommonBody },
      { body: CommonBody }
    >({
      query: ({ body }) => ({
        url: `${END_POINTS.addPromo}`,
        method: "POST",
        body,
      }),
    }),

    deleteByIdPromo: builder.query<
      CommonResponseType & { data: any },
      { id: any }
    >({
      query: ({ id }) => ({
        url: `${END_POINTS.deleteByIdPromo}/${id}/`,
        method: "DELETE",
      }),
    }),
  }),
});

export const {
  useLazyGetAllPromosQuery,
  useLazyDeleteByIdPromoQuery,
  useLazyGetPromoByIdQuery,
  useUpdatePromoMutation,
  useAddPromoMutation,
} = promoCodeApi;
